/**
 * React Query hooks for the audit log endpoint (M3.8).
 */
import { useAuth } from "@clerk/clerk-react";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import type { ApiError, AuditListResponse } from "@/lib/api-client";
import { fetchAuditLog } from "@/lib/api-client";

export const auditKeys = {
  all: ["audit"] as const,
  list: (params: { eventType?: string; limit?: number; before?: string } = {}) =>
    ["audit", "list", params] as const,
} as const;

export type UseAuditLogResult = UseQueryResult<AuditListResponse, ApiError | Error>;

export function useAuditLog(
  params?: { eventType?: string; limit?: number; before?: string },
): UseAuditLogResult {
  const { getToken } = useAuth();
  const resolvedParams = params ?? {};
  return useQuery<AuditListResponse, ApiError | Error>({
    queryKey: auditKeys.list(resolvedParams),
    queryFn: () =>
      fetchAuditLog(
        {
          ...(resolvedParams.eventType !== undefined ? { eventType: resolvedParams.eventType } : {}),
          ...(resolvedParams.limit !== undefined ? { limit: resolvedParams.limit } : {}),
          ...(resolvedParams.before !== undefined ? { before: resolvedParams.before } : {}),
        },
        { getToken: () => getToken() },
      ),
    enabled: params !== undefined,
  });
}
